/**
 * Core Configuration Constants
 *
 * @module src/core/config
 */

// Asset paths
export const ASSET_PREFIX = 'dist';
export const ASSET_LEGACY_PREFIX = 'dist-legacy';

// Static directory
export const STATIC_DIR = 'static';

// SSR paths
export const PWA_SSR_PREFIX = 'dist-server';
export const PWA_SSR_APP = 'ssrApp';

// Service worker files
export const SW_FILE = 'sw.js';
export const SW_KILLSWITCH_FILE = 'sw-killswitch.js';

// Source paths
export const PATH_SRC = 'src';
export const PATH_SERVER_SRC = 'server';
export const PATH_GENERATED = '__generated__';

// State IDs for hydration
export const GQL_STATE_ID = 'apollo-client-state';
export const REDUX_STATE_ID = 'redux-client-state';
export const APP_ENV_STATE_ID = 'app-env';

// Server environment types
export type ServerEnv = {
    MAGENTO_BACKEND_URL: string;
    NODE_ENV: string;
    PWA_DIR: string;
    SERVER_DOMAIN: string;
    SERVER_PWD: string;
    SERVER_SERVE_LOCAL: boolean;
    DISPLAY_SSR_ERROR: boolean;
    SERVER_PORT: number;
    RELEASE_STAGE: string;
};
